export default __webpack_public_path__ + "static/media/Kuthcheman Flamberge.83be8c74.jpg";